import React from 'react';

export type Locale = 'en' | 'ar';

export function LangToggle({
  locale,
  onChange,
  className = '',
}: {
  locale: Locale;
  onChange: (next: Locale) => void;
  className?: string;
}) {
  return (
    <div
      className={`inline-flex items-center rounded-md border p-0.5 ${className}`}
      style={{ borderColor: 'var(--border)' }}
      role="tablist"
      aria-label="Language"
    >
      <button
        type="button"
        role="tab"
        aria-selected={locale === 'en'}
        className="font-mono text-[11px] uppercase tracking-[0.08em] px-[11px] py-[5px] rounded transition-colors"
        style={{
          background: locale === 'en' ? 'var(--bg-elev)' : 'transparent',
          color: locale === 'en' ? 'var(--text)' : 'var(--secondary)',
        }}
        onClick={() => onChange('en')}
      >
        EN
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={locale === 'ar'}
        className="text-[11px] px-[11px] py-[5px] rounded transition-colors"
        style={{
          fontFamily: 'var(--font-arabic), var(--font-mono)',
          background: locale === 'ar' ? 'var(--bg-elev)' : 'transparent',
          color: locale === 'ar' ? 'var(--text)' : 'var(--secondary)',
        }}
        onClick={() => onChange('ar')}
      >
        العربية
      </button>
    </div>
  );
}

export default LangToggle;
